import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const SettingsIcon = ({ color = '#B5BCBD', size = '20', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.655 0c-.18 0-.293.14-.322.31l-1 3.654c-.778.237-1.519.552-2.226.929l-3.31-1.87c-.14-.099-.325-.126-.452 0L3.024 6.346c-.127.127-.1.3 0 .44l1.869 3.298a12.597 12.597 0 0 0-.917 2.239L.31 13.333c-.17.029-.31.142-.31.322v4.69c0 .18.14.293.31.322l3.654 1c.237.778.552 1.519.929 2.226l-1.87 3.31c-.099.14-.126.325 0 .452l3.322 3.31c.127.126.313.11.453.011l3.31-1.88c.702.373 1.44.68 2.214.916l1.011 3.678c.029.17.142.31.322.31h4.69c.18 0 .293-.14.322-.31l1.011-3.678a12.477 12.477 0 0 0 2.215-.917l3.31 1.881c.14.1.325.115.452-.012l3.321-3.31c.127-.126.1-.312 0-.452l-1.869-3.31c.377-.706.692-1.447.929-2.225l3.654-1c.17-.029.31-.142.31-.322v-4.69c0-.18-.14-.293-.31-.322l-3.666-1.011a12.6 12.6 0 0 0-.917-2.239l1.87-3.297c.099-.14.126-.314 0-.44l-3.322-3.322c-.127-.127-.313-.1-.453 0l-3.31 1.869a12.414 12.414 0 0 0-2.225-.929l-1-3.654c-.029-.17-.142-.31-.322-.31h-4.69zM16 9.524A6.475 6.475 0 0 1 22.476 16 6.475 6.475 0 0 1 16 22.476 6.475 6.475 0 0 1 9.524 16 6.475 6.475 0 0 1 16 9.524z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

SettingsIcon.propTypes = propTypes;

export default SettingsIcon;
